/*-----------------------------------------------------
 *
 *	This component plots the coordinates we add and shows the 
 * 	polynomial model on a graph. 
 *	
 * ----------------------------------------------------
 */

/* eslint react-hooks/exhaustive-deps: 0 */  // --> OFF

import React from "react";
import PolynomialRegression from "./PolynomialRegression";
import { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
const Chart = require('chart.js');

const useStyles = makeStyles((theme) => ({

  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  canvas: {
    width: '800px',
    height: 'auto',
  }
}));

interface GraphProps {
  color: string
  order: any
  x: number[]
  y: number[]
}

export default function Graph(props: GraphProps) {

  const chart = useRef<any>();
  const model = useRef<PolynomialRegression>(new PolynomialRegression());
  const classes = useStyles();

   //console.log('DEG', props.order)
  // The plot() function loads immediately when this whole component is rendered
  useEffect(() =>
    plot()
    ,
    []);

  // props.x, props.y, and props.deg are in the dependency array so whenever any of these values change, 
  // the fit() and plot_update() functions re-run
  useEffect(
    () => {
      fit();
      plot_update();
    },
    [props.x, props.y, props.order]
  )


  // creates a Graph
  function plot() {
    chart.current = new Chart(chart.current, {
      type: 'scatter',
      data: {
        datasets: [
          {
            label: `Polynomial Degree: ${String(props.order)}`,
            data: [],
            fill: false,
            pointBackgroundColor: [],
          },
        ],
      },
    })
  }

  function fit() {

    // reset the model if there's is no data
    if (props.x.length === 0 && props.y.length === 0) {
      model.current = new PolynomialRegression()
    } else {
      //else, train the model
      model.current.train(props.x, props.y, props.order)
    }
  }

  // plots points on the graph as we click on more points on the grid (PointDrawer component)
  function plot_update() {
    let data = [],
      regression_points = []
    for (let i = 0; i < props.x.length; i++) {
      data.push({ x: props.x[i], y: props.y[i] })
    }
    for (let i = 0; i < 1; i += 0.05) {
      regression_points.push({ x: i, y: model.current.predict(i) })
    }
    chart.current.data.datasets[0].data = data
    chart.current.data.datasets[0].label = `Polynomial Degree: ${String(props.order)}`
    chart.current.data.datasets[0].pointBackgroundColor.push(props.color)
    chart.current.data.datasets[1] = {
      type: 'line',
      label: model.current.expression,
      function: function (x: any) {
        return model.current.predict(x)
      },
      data: regression_points,
      borderColor: 'rgba(0,0,255,1)',
      fill: false,
    }
    chart.current.update()
  }

  return (
    <div className={classes.container}>
      <div className={classes.canvas}>
        <canvas ref={chart} />
      </div>
    </div>
  )
}

